import React from 'react';
import { ArrowDown } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center justify-center pt-24 pb-16 px-4 overflow-hidden bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-zinc-900 via-black to-black" data-id="element-91">
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 pointer-events-none" data-id="element-92" />

      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="text-center lg:text-left" data-id="element-94">
          <div className="inline-block bg-green-500/10 border border-green-500/20 rounded px-3 py-1 mb-6" data-id="element-95">
            <span className="text-green-500 font-bold uppercase tracking-wider text-sm" data-id="element-96">
              NADIE TE ENSEÑÓ A PRODUCIR COMIDA EN CASA… CON UN SISTEMA REAL.
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl font-black text-white leading-tight mb-6" data-id="element-97">
            Dejar tu huerta a medias no es falta de ganas.{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-green-600" data-id="element-98">
              Es falta de un sistema que te guíe.
            </span>
          </h1>

          <p className="text-xl text-gray-400 mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed" data-id="element-99">
            Huerta Productiva 360° es un método paso a paso para producir
            alimentos todo el año, organizar tu espacio y escalar si querés
            emprender.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-100">
            <Button size="xl" onClick={scrollToCheckout} className="group" data-id="element-101">
              QUIERO EMPEZAR HOY
              <ArrowDown className="ml-2 w-5 h-5 group-hover:translate-y-1 transition-transform" data-id="element-102" />
            </Button>
          </div>

          <div className="mt-8 flex items-center justify-center lg:justify-start gap-4 text-sm text-zinc-500" data-id="element-103">
            <div className="flex -space-x-2" data-id="element-104">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-zinc-800 border-2 border-black flex items-center justify-center text-xs text-white font-bold" data-id="element-105">
                  {String.fromCharCode(64 + i)}
                </div>)}
            </div>
            <p data-id="element-106">+800 huertas activas en Argentina</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative" data-id="element-107">
          <div className="absolute inset-0 bg-green-500/20 blur-[100px] rounded-full pointer-events-none" data-id="element-108" />
          <img src="https://cdn.magicpatterns.com/uploads/1T83YRh2zHMBAWZqHaKiSV/ChatGPT_Image_24_feb_2026,_15_07_28.png" alt="Huerta Productiva 360° — Manual Principal" className="relative z-10 w-full max-w-md mx-auto rounded-xl shadow-2xl border border-zinc-800 rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-109" />
        </motion.div>
      </div>
    </section>;
}